export enum EAgentRegistrationCommunicationMethod {
  CALL_PHONE = 'Звонок на телефон',
  EMAIL = 'Электронная почта',
}
